import neomaPic from "@/public/images/artists/neoma.png";
import { Artist } from "@/types/types";

export const neoma = {
  id: "291",
  name: "Neoma",
  image: neomaPic,
  description: `A raw, fiery voice with a biting edge and playful attitude.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fneoma-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Female",
    tags: {
      primary: ["Unprocessed", "Belting", "Pop", "RnB", "Afrobeat"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Mid",
        high: "Mid",
      },
      specific: {
        low: 50,
        high: 70,
      },
      sweetSpot: 60,
    },
  },
} as const satisfies Artist;
